(function ($) {
    'use strict';
    window.require([ "/js/slider-slick/slick.min.js"], function () {
    var productList = $('.UC171 .ProductList');

    productList.each(function(){

        var sliderDesktop = $(this).data('slider-desktop');
        var sliderTablet = $(this).data('slider-tablet');
        var sliderMobile = $(this).data('slider-mobile');

        console.log( sliderDesktop, sliderTablet, sliderMobile, $(this).find('.js-fragment-container'));

        if (sliderDesktop && sliderTablet && sliderMobile) {
            $(this).find('.js-fragment-container').slick({
                fade: false,       // fade or not fade transition effect (true, false)
                dots: true,        // show/hide dots (true, false)
                arrows: false,     // show/hide arrows (true, false)
                infinite: true,    // enable/disble infinite option (true, false)
                speed: 500,        // transition speed (<number>ms)
                autoplay: false,   // enable/disable autoplay (true, false)
                prevArrow: "<button type='button' class='slick-prev'><i class='fa fa-chevron-left' aria-hidden='true'></i></button>",
                nextArrow: "<button type='button' class='slick-next'><i class='fa fa-chevron-right' aria-hidden='true'></i></button>",
                slidesToShow: sliderDesktop,
                slidesToScroll: sliderDesktop,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            arrows: false,
                            slidesToShow: sliderTablet,
                            slidesToScroll: sliderTablet
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            slidesToShow: sliderMobile,
                            slidesToScroll: sliderMobile
                        }
                    }
                ]
            });
        }
    });

    });
})(jQuery);